import _ from 'lodash'
import ShipmentUnit from './ShipmentUnit'

export default class Release {
  id = 0
  date = null
  invoice = null
  senderCustomer = {
    label: null,
    value: null
  }
  receiverCustomer = {
    label: null,
    value: null
  }
  state = {
    label: null,
    value: null
  }
  newReceiverCustomer = {
    label: null,
    value: null
  }
  newPaymentDate = null
  shipments = [
    new ShipmentUnit({})
  ]
  payerTitle = null
  payerCompanyCode = null
  paymentDate = null
  marking = null
  lotNo = null
  receiverTitle = null
  receiverCompanyCode = null

  constructor (data) {
    _.forEach(data, (value, field) => {
      if (this.hasOwnProperty(field)) {
        this[field] = value
      }
    })

    if (data.shipments) {
      this.shipments = _.map(data.shipments, shipment => new ShipmentUnit(shipment))
    }
  }
}
